import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { MatchDetail } from "@/components/MatchDetail";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import volleyballApi from "@/services/api";

export const MatchDetailPage = () => {
  const { matchId } = useParams();
  const navigate = useNavigate();
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchMatch = async () => {
      try {
        const data = await volleyballApi.getMatchDetail(matchId);
        setMatch(data);
      } catch (error) {
        console.error("Error loading match:", error);
        setMatch(null);
      } finally {
        setLoading(false);
      }
    };
    
    fetchMatch();
  }, [matchId]);
  
  if (loading) {
    return (
      <div className="min-h-screen">
        <Navigation />
        <div className="container mx-auto px-4 py-12 text-center">
          <p className="text-muted-foreground">Caricamento...</p>
        </div>
        <Footer />
      </div>
    );
  }
  
  if (!match) {
    return (
      <div className="min-h-screen">
        <Navigation />
        <div className="container mx-auto px-4 py-12 text-center">
          <h1 className="text-3xl font-bold mb-4">Partita non trovata</h1>
          <Button onClick={() => navigate('/calendario')}>
            Torna al Calendario
          </Button>
        </div>
        <Footer />
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Indietro
        </Button>
        
        <MatchDetail match={match} />
      </div>
      
      <Footer />
    </div>
  );
};

export default MatchDetailPage;
